export default class InfinityCarousel {
    static init(): void {
        this.handleCarousels();
    }

    static handleCarousels(): void {
        const crsls = document.querySelectorAll('.infinity-carousel');
        if (crsls) {
            crsls.forEach((carousel) => {
                //   const carousel = document.querySelector('.infinity-carousel') as HTMLElement | null;
                const carouselItems = carousel.querySelector('.infinity-carousel__items') as HTMLElement;
                const items = carousel?.querySelectorAll('.infinity-carousel__item');
                const next = carousel?.querySelector('.infinity-carousel__arrow--right img');
                const prev = carousel?.querySelector('.infinity-carousel__arrow--left img');

                if (carousel && items && prev && next) {
                    const itemsCount = items.length;
                    for (let i = 0; i < 2; i++) {
                        items.forEach((item) => {
                            carouselItems.appendChild(item.cloneNode(true));
                        });
                    }

                    const itemWidth = items[0].clientWidth;
                    carouselItems.scrollLeft = itemsCount * itemWidth;

                    prev.addEventListener('click', () => {
                        // const carousel = document.querySelector('.infinity-carousel__items');
                        const itemWidth = items[0].clientWidth;
                        carouselItems?.scrollBy({
                            top: 0,
                            left: -itemWidth,
                            behavior: 'smooth',
                        });
                    });

                    next.addEventListener('click', () => {
                        // const carousel = document.querySelector('.infinity-carousel__items');
                        const itemWidth = items[0].clientWidth;

                        if (carouselItems) {
                            carouselItems.scrollBy({
                                top: 0,
                                left: itemWidth,
                                behavior: 'smooth',
                            });
                        }
                    });

                    carouselItems.addEventListener('scrollend', () => {
                        const windowWidth = window.innerWidth;
                        const itemsVisible = Math.round(windowWidth / itemWidth);
                        if (carouselItems?.scrollLeft + windowWidth >= carouselItems?.scrollWidth) {
                            carouselItems.scrollLeft = itemsCount * itemWidth + itemWidth * (itemsCount - itemsVisible);
                        }
                        if (carouselItems?.scrollLeft == 0) {
                            carouselItems.scrollLeft = items.length * itemWidth;
                        }
                    });
                }
            });
        }
    }
}
